import { useEffect, useState } from "react";
import api from "../api/axios";
import Swal from "sweetalert2";

function NewsList() {
  const [services, setServices] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    loadServices();
  }, []);

  const loadServices = async () => {
    try {
      const response = await api.get("/Master/GetNews");

      setServices(response.data);
    } catch (error) {
      Swal.fire({
        icon: "error",
        title: "Error",
        text: "Unable to load services",
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="card shadow">
      <div className="card-header bg-primary text-white">
        <h4 className="mb-0">News List</h4>
      </div>

      <div className="card-body">
        {loading ? (
          <div className="text-center">Loading...</div>
        ) : (
          <div className="table-responsive">
            <table className="table table-bordered table-striped">
              <thead className="table-dark">
                <tr>
                  <th>ID</th>
                  <th>Heading</th>
                  <th>Description</th>
                  <th>Images</th>
                  <th>Is Home</th>
                  <th>Created Date</th>
                  <th>Status</th>
                </tr>
              </thead>

              <tbody>
                {services.length > 0 ? (
                  services.map((item) => (
                    <tr key={item.id}>
                      <td>{item.id}</td>
                      <td>{item.name}</td>
                      <td>{item.description}</td>
                      <td>
                        {item.newsImgS && (
                          <img
                            src={`https://localhost:7038/${item.newsImgS}`}
                            alt="images"
                            width="60"
                            className="me-2"
                          />
                        )}
                        {item.newsImgB && (
                          <img
                            src={`https://localhost:7038/${item.newsImgB}`}
                            alt="images"
                            width="60"
                          />
                        )}
                      </td>
                      {/* const imageBaseUrl = "https://services.mcambala.gov.in";

<img src={`${imageBaseUrl}/${item.newsImgS}`} alt="Small" width="60" />
<img src={`${imageBaseUrl}/${item.newsImgB}`} alt="Big" width="60" /> */}
                      <td>
                        {item.isHome === 1 ? (
                          <span className="badge text-success">
                            <i className="bi bi-eye-fill"></i> Yes
                          </span>
                        ) : (
                          <span className="badge text-danger">
                            <i className="bi bi-eye-slash-fill"></i> No
                          </span>
                        )}
                      </td>
                      <td>{item.created_Date}</td>

                      <td>
                        {/* {item.isActive
                            ? "Active"
                            : "Inactive"} */}

                        {item.status_Info === 1 ? (
                          <span className="badge bg-success">
                            <i className="bi bi-eye-fill"></i> Active
                          </span>
                        ) : (
                          <span className="badge bg-danger">
                            <i className="bi bi-eye-slash-fill"></i> Inactive
                          </span>
                        )}
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="5" className="text-center">
                      No Record Found
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        )}
      </div>
    </div>
  );
}

export default NewsList;
